import { Link, Outlet, createFileRoute } from '@tanstack/react-router';
import {
  Activity,
  KeyRound,
  Settings,
  Shield,
  Sparkles,
  TerminalSquare,
  UserRound,
} from 'lucide-react';
import { PageHeader } from '@/components/page-header';

export const Route = createFileRoute('/_app/account')({ component: AccountLayout });

const tabs = [
  { to: '/account', label: 'Profile', icon: UserRound, exact: true },
  { to: '/account/security', label: 'Security', icon: Shield, exact: false },
  { to: '/account/ssh-keys', label: 'SSH keys', icon: KeyRound, exact: false },
  { to: '/account/api-keys', label: 'API keys', icon: TerminalSquare, exact: false },
  { to: '/account/ai', label: 'AI', icon: Sparkles, exact: false },
  { to: '/account/activity', label: 'Activity', icon: Activity, exact: false },
  { to: '/account/settings', label: 'Settings', icon: Settings, exact: false },
] as const;

function AccountLayout() {
  return (
    <div className="mx-auto w-full max-w-4xl">
      <PageHeader
        title="Account"
        icon={UserRound}
        description="Manage your profile, security, sessions and preferences."
      />
      <nav
        className="-mx-4 mb-6 flex gap-1 overflow-x-auto border-b px-4 [scrollbar-width:none] sm:mx-0 sm:px-0"
        aria-label="Account sections"
      >
        {tabs.map(({ to, label, icon: Icon, exact }) => (
          <Link
            key={to}
            to={to}
            activeOptions={{ exact }}
            className="text-muted-foreground hover:text-foreground group/tab -mb-px flex shrink-0 items-center gap-2 border-b-2 border-transparent px-3 py-2.5 text-sm font-medium transition-colors duration-150 aria-[current=page]:border-brand aria-[current=page]:text-foreground"
          >
            <Icon
              className="text-subtle group-aria-[current=page]/tab:text-brand size-4"
              aria-hidden
            />
            {label}
          </Link>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
